import { Injectable } from '@angular/core';
import { ProblemService } from './problem.service';
import { AircraftTypeService } from '@app/report-form/shared/services/aircraft-type.service';
import { AircraftService } from '@app/report-form/shared/services/aircraft.service';
import { PositionService } from '@app/report-form/shared/services/position.service';
import { FatigueReportService } from '@app/report-form/shared/services/fatigue-report.service';
import {ExpectedActionsService} from "@app/report-form/shared/services/expected-actions.service";

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  constructor(
    private aircraftTypeService: AircraftTypeService,
    private aircraftService: AircraftService,
    private positionService: PositionService,
    private problemService: ProblemService,
    private fatigueReportService: FatigueReportService,
    private expectedActionsService: ExpectedActionsService
  ) {}

  public loadAndCacheDictionaries() {
    console.log('== initializing dictionaries cache ==');

    this.aircraftTypeService.getAircraftTypes().subscribe();
    this.aircraftService.getAircrafts().subscribe();
    this.positionService.getPositions().subscribe();
    this.problemService.getCategoriesWithProblems().subscribe();
    this.problemService.getCategoriesWithDeletedProblems().subscribe();
    this.fatigueReportService.getAircraftTypes().subscribe();
    this.fatigueReportService.getAlertnessLevels().subscribe();
    this.fatigueReportService.getConfidentialityLevels().subscribe();
    this.fatigueReportService.getContributoryFactors().subscribe();
    this.fatigueReportService.getFatigueCategories().subscribe();
    this.fatigueReportService.getSymptomTypes().subscribe();
    this.fatigueReportService.getSymptoms().subscribe();
    this.fatigueReportService.getTimeZoneData().subscribe();
    this.expectedActionsService.expectedActions$.subscribe();
  }
}
